<template>
  <div>
    <page-intro>
      <template v-slot:heading>Платежи и акты</template>
      <template v-slot:info>
        <div class="text-medium">
          <div>Текущий баланс: {{ formatNumber(balance, 'currency') }}</div>
          <div>Ежемесячный платеж: {{ formatNumber(monthlyPayment, 'currency') }}</div>
        </div>
      </template>
    </page-intro>
    <div v-loading="$mip('getPayments')" class="widget">
      <div class="widget__body">
        <el-table :row-class-name="() => 'payments__table__row_non-hover'" :data="documents" :fit="false">
          <el-table-column
            label="Месяц"
            prop="date"
            :width="140"
            :formatter="getPaymentPreiod" />
          <el-table-column label="Платежи" :width="280">
            <template v-slot="{ row: { payments }}">
              <div v-for="(payment, i) in payments" :key="i" class="text-cell">
                {{ payment.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Акты" :width="280">
            <template v-slot="{ row: { acts }}">
              <div
                v-for="(act, i) in acts"
                :key="i"
                class="link text-cell"
                @click="downloadDocument(act)">
                {{ act.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Баланс"
            prop="balance"
            :width="120" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import { formatDate, formatNumber } from '@/utils'

  export default {
    components: {
      PageIntro
    },

    data() {
      return {
        documents: []
      }
    },

    computed: {
      balance() {
        return this.$store.state.user.accInfo.balance || 0
      },

      monthlyPayment() {
        return this.$store.state.user.accInfo.monthlyPayment || 0
      }
    },

    async created() {
      this.documents = (await this.$http.getPayments()).data
    },

    methods: {
      formatNumber,
      getPaymentPreiod({ date }) {
        const formatted = formatDate(date, { year: 'numeric', month: 'long' })
        return formatted.charAt(0).toUpperCase() + formatted.slice(1)
      },

      downloadDocument({ name, documentId }) {
        this.$http.getFile('getActPrintForm', { fileName: `Акт № ${name}`, params: { actId: documentId } })
      }
    }
  }
</script>

<style lang="scss">
  .payments__table__row_non-hover:hover>td {
    background-color: #FFF !important;
  }

  .text-cell {
    word-break: normal;
  }
</style>